import { Injectable,LOCALE_ID, Inject } from '@angular/core';
//import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { HttpClient,HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { PageItem } from './page';
import { DomSanitizer, SafeResourceUrl, SafeHtml , SafeUrl} from '@angular/platform-browser';
import { Image} from '@ks89/angular-modal-gallery';



// @Injectable({providedIn : 'root'}) {}
@Injectable()

export class PageService {


  currentPage:PageItem;
  apiUrl : string = "https://backend.industriapaisaia.eus/wp-json/wp/v2"

  constructor(
    private http: HttpClient,
    public  sanitizer: DomSanitizer,
    @Inject(LOCALE_ID) protected localeId: string
  ) { }

  // getItems() : void {
  //   //console.log("getItems");
  //   let url = `${this.apiUrl}/pages`;
  //   let search = new URLSearchParams();
  //   search.set('foo', 'moo');
  //   search.set('limit', "25");
  //   search.set('_embed','');
  //   this.http.get(url,{search:search})
  //     .toPromise()
  //     .then(res => console.log(res.json()));
  // }

  getLink(locale) {
    if (this.currentPage) {
      return this.currentPage.language[locale].slug;
    } else {
      return ''
    }
  }

  getParentPages() : Observable<PageItem[]> {
    let search = new URLSearchParams();
    search.set('parent','0');
    return this.getPages(search);
  }

  getPage(slug:string) {
    let search = new URLSearchParams();
    search.set('slug',slug);
    return this.getPages(search);
  }

  getChilds(id:string) {
    // console.log("childs de: "+id);
    let search = new URLSearchParams();
    search.set('parent',id);
    return this.getPages(search,true);
  }

  getPages(searchParams, childs = false) : Observable<PageItem[]> {
    searchParams.set('orderby','menu_order');
    //searchParams.set('_embed','');
    searchParams.set('per_page',20);
    searchParams.set('lang',this.localeId);
    //searchParams.set('context','embed');

    let url = `${this.apiUrl}/pages`+'?_embed&'+searchParams.toString();
    return this.http.get<any[]>(url)
      .map(res => {

        //console.log(res)

        return res.map( (item) => {

          //console.log(item)

          let page = new PageItem(
            item.id as string,
            item.title.rendered,
            item.acf.descripcion,
            item.content.rendered,
            item.slug,
            item.parent
          );

          /*transalte*/
          page.language = item.language;

          /*parent */
          page['parent_title']=item['parentTitle']['title'];
          page['parent_link']=item['parentTitle']['link'];

          if (item['acf']['pdf']) {
            page['pdf']=item['acf']['pdf'];
            if (item['acf']['pagina_del_pdf']) page['pdf']['url'] = page['pdf']['url']+"#page="+item['acf']['pagina_del_pdf'];
          }
          else { page['pdf']=null; }

        /* chilsd */
          page["hasChild"]=item["hasChild"];
          // if (item["hasChild"]) {
          //   //
          //   let search = new URLSearchParams();
          //   search.set('parent',id);
          //   searchParams.set('orderby','menu_order');
          //   searchParams.set('_embed','');
          //   this.http.get(url,{search:searchParams})
          // }

          /* featured images */
          if ( !childs && item["_embedded"]["wp:featuredmedia"]) {
            page["featuredmedia"] = item["_embedded"]["wp:featuredmedia"];

            if (item["_embedded"]["wp:featuredmedia"][0]["media_details"]["sizes"]["large"]) {
              // page['background_image'] = item.acf.background_image.sizes.large;
              page['background_image'] = item["_embedded"]["wp:featuredmedia"][0]["media_details"]["sizes"]["large"]["source_url"]
            } else if (item["_embedded"]["wp:featuredmedia"][0]["media_details"]["sizes"]["full"]) {
              if ( item["_embedded"]["wp:featuredmedia"][0]["media_details"]["sizes"]["full"]["source_url"] == 'undefined' ) { page['background_image']=''}
              else { page['background_image'] = item["_embedded"]["wp:featuredmedia"][0]["media_details"]["sizes"]["full"]["source_url"] }
            } else  {
              page['background_image'] = '';
            }
          }

          /* Publitas */
          if (!childs && item["acf"] && item["acf"]["libro_publitas"]) {
            //page["publitas_link"] = this.sanitizer.bypassSecurityTrustUrl(item["acf"]["libro_publitas"]);
            page["publitas_link"] = item["acf"]["libro_publitas"];
            //this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeUrl);
          }

          /* Gallery */
          // console.log(item['gallery'])
          if (!childs && item["gallery"])  {
            page['gallery'] = [];
            let c = 0;
            item["gallery"].forEach( (i)=> {
              var im = new Image(c, { img: i['modal'], title: i['title'], alt:i['title'], description: i['desc'] },{ img: i['thumb'], title: i['title'], alt:i['title'], description: i['desc'] });
              page['gallery'].push(im);
              c++;
            });
          }

          let link = document.createElement('a');
          link.href = item.link;
          page['link'] = link.pathname;

          return page;
        });
      });
  }

}
